import { render, staticRenderFns } from "./BannerInner.vue?vue&type=template&id=4c0abfc4&scoped=true"
import script from "./BannerInner.vue?vue&type=script&lang=js"
export * from "./BannerInner.vue?vue&type=script&lang=js"
import style0 from "./BannerInner.vue?vue&type=style&index=0&id=4c0abfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0abfc4",
  null
  
)

export default component.exports